
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import {loadPaginatedECShopCodes}  from "@/api/onlineshop";
// import BalanceDetails from "@/components/cards/BalanceDetails.vue";
// import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue";
// import ECShopAdvisory from "@/views/ECShopAdvisory.vue";

export default defineComponent({
  name: "shopcodes",
  components: {
    // BalanceDetails,
    // CompanyPolicy,
    // ECShopAdvisory
  },
  data() { 
    return { 
      list : [],
      loading: true,
    }
  },
  mounted(){
      this.loadPaginatedECShopCodes();
  },
  methods : {
    async loadPaginatedECShopCodes(){ 
      this.loading = true;
      const response = await loadPaginatedECShopCodes(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("onlineShopTab") || "0");
      setCurrentPageTitle("Online Shop");

    });
    
  }
});
